import React, { useState } from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import {
  Box,
  FormControl,
  FormGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Link } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2rem",
    marginTop: "4rem",
    width: "25rem",
    backgroundColor: "#F5F6FA",
  },
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  icon: {
    cursor: "pointer",
    width: "22px !important",
    height: "22px !important",
  },
  headerTitle: {
    color: "rgb(74, 74, 74)",
  },
  title: {
    color: "#4A4A4A",
  },
}));

const StatusSummaryDrawer = (props) => {
  const classes = useStyles();
  const { parentCall } = props;
  const [drawerFlag, setDrawerFlag] = useState({ drawerFlag: false });
  const globaluserData = useSelector(state=>state.commonReducer)
  const themeColor = globaluserData.role === "admin" ? "#EF7000" : "#EF7000";
    // sessionStorage.getItem("role") == "admin" ? "#EF7000" : "#EF7000";

  const statusArray = [
    { status: "Shortlist", assigment: "37" },
    { status: "Chemistry", assigment: "81" },
    { status: "Contracting session", assigment: "88" },
    { status: "Line manager call", assigment: "12" },
    { status: "Session 1", assigment: "27" },
    { status: "Session 2", assigment: "18" },
    { status: "Session 3", assigment: "37" },
    { status: "Session 4", assigment: "36" },
    { status: "Session 5", assigment: "15" },
    { status: "Session 6", assigment: "20" },
  ];

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerFlag(open);
    !open && parentCall(false);
  };

  const list = (anchor) => (
    <Box className={classes.root}>
      <Grid container xs={12} direction="row" justify="space-between">
        <Typography variant="subtitle1" className={classes.headerTitle}>
          Session status summary
        </Typography>

        <Link
          color="inherit"
          className={classes.icon}
          onClick={() => {
            parentCall(false);
          }}
        >
          <CloseIcon fontSize="small" />
        </Link>
      </Grid>

      <Box py={2}>
        <Grid
          style={{ backgroundColor: "#FFF", padding: 16 }}
          container
          xs={12}
          direction="row"
        >
          <Grid item xs={6}>
            <Typography variant="h2" gutterBottom className={classes.title}>
              <Box fontWeight="bold">Current status</Box>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="h2"
              gutterBottom
              style={{ textAlign: "center" }}
              className={classes.title}
            >
              <Box fontWeight="bold">Number of assignments</Box>
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box>
        {props.statistics.length > 0 &&
          props.statistics.map((data) => {
            return (
              <Box
                component="button"
                onClick={() => {
                  props.fetchAssignmentsByStatistics(data?.label);
                  props?.setFilterStatisticsValue(data.label);
                  parentCall(false);
                }}
                style={{
                  border: 0,
                  boxShadow: 0,
                  backgroundColor: "#fff",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Grid
                  container
                  xs={12}
                  direction="row"
                  alignItems="center"
                  justify="space-between"
                  style={{
                    borderBottom: "1px #ddd solid",
                    padding: "10px 16px",
                    cursor: "pointer",
                  }}
                >
                  <Grid item xs={6}>
                    <Typography
                      variant="h2"
                      gutterBottom
                      className={classes.title}
                      style={{
                        color:
                          data.label === props?.filterStatisticsValue
                            ? themeColor
                            : "",
                      }}
                    >
                      {data?.label || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      className={classes.title}
                      style={{
                        textAlign: "center",
                        color:
                          data.label === props?.filterStatisticsValue
                            ? themeColor
                            : "",
                      }}
                    >
                      {data?.value}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Box
                      className={classes.icon}
                      style={{
                        marginRight: "40px",
                        color:
                          data.label === props?.filterStatisticsValue
                            ? themeColor
                            : "",
                      }}
                      onClick={() => {
                        console.log("dd", data);
                      }}
                    >
                      <ArrowForwardIcon />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
  return (
    <>
      <div>
        <React.Fragment>
          <SwipeableDrawer
            anchor={"right"}
            open={drawerFlag}
            onClose={toggleDrawer("drawerFlag", false)}
            onOpen={toggleDrawer("drawerFlag", true)}
          >
            {list("right")}
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  );
};

export default StatusSummaryDrawer;
